export const colorTokens = {
    primary: {
        primary98: '#e3ffff',
        primary96: '#c6feff',
        primary94: '#a5fdff',
        primary92: '#7cfbff',
        primary87: '#63eef2',
        primary35: '#005c5e',
        primary25: '#004344',
        primary24: '#004042',
        primary22: '#003b3d',
        primary17: '#003031',
        primary12: '#002425',
        primary6: '#001717',
        primary5: '#001415',
        primary4: '#001112',
        primary100: '#ffffff',
        primary99: '#f1ffff',
        primary95: '#b7fdff',
        primary90: '#6df6fa',
        primary80: '#4adade',
        primary70: '#19bec2',
        primary60: '#00a1a4',
        primary50: '#008588',
        primary40: '#00696c',
        primary30: '#004f51',
        primary20: '#003738',
        primary10: '#002021',
        primary0: '#000000',
    },
    secondary: {
        secondary0: '#000000',
        secondary10: '#290055',
        secondary20: '#450086',
        secondary30: '#6300bb',
        secondary40: '#7d2dd9',
        secondary50: '#974df4',
        secondary60: '#ae71ff',
        secondary70: '#c396ff',
        secondary80: '#d8b9ff',
        secondary90: '#eedcff',
        secondary95: '#f8edff',
        secondary99: '#fffbff',
        secondary100: '#ffffff',
        secondary4: '#170035',
        secondary5: '#1b003b',
        secondary6: '#1e0041',
        secondary12: '#2f005e',
        secondary17: '#3d0077',
        secondary22: '#4b0090',
        secondary24: '#51009b',
        secondary25: '#5400a0',
        secondary35: '#7019cc',
        secondary87: '#e7d1ff',
        secondary92: '#f2e2ff',
        secondary94: '#f6e9ff',
        secondary96: '#faf0ff',
        secondary98: '#fff7ff',
    },
    tertiary: {
        tertiary0: '#000000',
        tertiary10: '#001d34',
        tertiary20: '#003256',
        tertiary30: '#004a7a',
        tertiary40: '#0062a0',
        tertiary50: '#2c7bbd',
        tertiary60: '#4c95d9',
        tertiary70: '#6ab0f5',
        tertiary80: '#9bcbff',
        tertiary90: '#d0e4ff',
        tertiary95: '#e9f1ff',
        tertiary99: '#fcfcff',
        tertiary100: '#ffffff',
        tertiary4: '#000f1f',
        tertiary5: '#001223',
        tertiary6: '#001427',
        tertiary12: '#00213b',
        tertiary17: '#002c4b',
        tertiary22: '#00375d',
        tertiary24: '#003c64',
        tertiary25: '#003e67',
        tertiary35: '#00568c',
        tertiary87: '#c0ddff',
        tertiary92: '#daeaff',
        tertiary94: '#e4efff',
        tertiary96: '#eef4ff',
        tertiary98: '#f8f9ff',
    },
    error: {
        error0: '#000000',
        error10: '#410002',
        error20: '#690006',
        error30: '#93000d',
        error40: '#bb171c',
        error50: '#df3531',
        error60: '#ff544c',
        error70: '#ff897e',
        error80: '#ffb4ac',
        error90: '#ffdad6',
        error95: '#ffedea',
        error99: '#fffbff',
        error100: '#ffffff',
        error4: '#270001',
        error5: '#2d0001',
        error6: '#310001',
        error12: '#490003',
        error17: '#5c0005',
        error22: '#710008',
        error24: '#790009',
        error25: '#7d0009',
        error35: '#a90111',
        error87: '#ffcfc9',
        error92: '#ffe2de',
        error94: '#ffe9e6',
        error96: '#fff0ee',
        error98: '#fff8f7',
    },
    neutral: {
        neutral0: '#000000',
        neutral4: '#1a1d21',
        neutral6: '#101415',
        neutral10: '#191c1d',
        neutral12: '#1d2021',
        neutral17: '#272b2b',
        neutral20: '#2e3132',
        neutral22: '#323536',
        neutral24: '#363a3a',
        neutral30: '#444748',
        neutral40: '#5c5f5f',
        neutral50: '#747878',
        neutral60: '#8e9192',
        neutral70: '#a9acac',
        neutral80: '#c4c7c7',
        neutral87: '#d8dadb',
        neutral90: '#e1e3e3',
        neutral92: '#e6e8e9',
        neutral94: '#eceeef',
        neutral95: '#eff1f1',
        neutral96: '#f2f4f4',
        neutral99: '#fafdfd',
        neutral100: '#ffffff',
        neutral5: '#0e1212',
        neutral25: '#393c3d',
        neutral35: '#505354',
        neutral98: '#f8fafa',
    },
    neutralVariant: {
        neutralVariant0: '#000000',
        neutralVariant10: '#141d1e',
        neutralVariant20: '#293233',
        neutralVariant30: '#3f484a',
        neutralVariant40: '#576061',
        neutralVariant50: '#6f797a',
        neutralVariant60: '#899294',
        neutralVariant70: '#a3adae',
        neutralVariant80: '#bec8ca',
        neutralVariant90: '#dae4e6',
        neutralVariant95: '#e9f3f4',
        neutralVariant99: '#f5feff',
        neutralVariant100: '#ffffff',
        neutralVariant4: '#071011',
        neutralVariant5: '#091214',
        neutralVariant6: '#0c1516',
        neutralVariant12: '#182122',
        neutralVariant17: '#222c2d',
        neutralVariant22: '#2d3638',
        neutralVariant24: '#323b3c',
        neutralVariant25: '#343d3e',
        neutralVariant35: '#4b5455',
        neutralVariant87: '#d2dcdd',
        neutralVariant92: '#e0eaeb',
        neutralVariant94: '#e6f0f1',
        neutralVariant96: '#ecf5f7',
        neutralVariant98: '#f1fbfc',
    },
    base: {
        white: '#ffffff',
        black: '#000000',
    },
};
